// extracted by mini-css-extract-plugin
export default {"tooltip":"FT-z","arrow":"GT-z"};